/**
 * Implements a row with clickable images
 */
import { Network } from '@kattana-io/common';
import { networksWithData } from '../NetworkSelector/core';
import Image from '../../atoms/Image';

import './styles.scss';

export const CHAIN_SELECTOR_OPTIONS = networksWithData.map((chain) => ({
  label: chain.getTitle(),
  value: chain.getSlug(),
  image: chain.getImage(),
}));

interface IChainSelectorProps {
  selected: string;
  onSet: (val: string) => void;
  networks?: Network[];
}

/**
 * Interactive chain selector
 * @param props
 * @returns
 */
const ChainSelector = ({ selected, onSet, networks }: IChainSelectorProps) => (
  <div className='chain__selector'>
    {(networks || networksWithData).map((item?: Network) => {
      if (!item) {
        return;
      }

      return (
        <div
          key={item?.chain}
          className={`chain__selector__item ${
            item.getSlug() == selected ? 'chain__selector__item--active' : ''
          } network_selector--${item.chain}`}
          onClick={() => onSet(item.getSlug())}
        >
          <Image src={item.getImage()} size='l' alt={item.getName()} />
        </div>
      );
    })}
  </div>
);

export default ChainSelector;
